(function () {
  'use strict';

  angular
    .module('hq.tools.lighting')
    .provider('hqTLightingRouter', RouterStateProvider);

  /**
   * @ngdoc service
   * @module hq.tools.lighting
   * @name hqTLightingRouterProvider
   * @description Used to configure router state during config stage.
   * @requires $urlRouterProvider
   * @requires $stateProvider
   * @requires hqTLightingLanguageProvider
   * @example
   * <pre>
   * app.config(function(hqTLightingRouterProvider) {
   *   hqTLightingRouterProvider
   *     .setState();
   * });
   * </pre>
   */
  function RouterStateProvider(
    $urlRouterProvider,
    $stateProvider,
    hqTLightingLanguageProvider
  ) {
    'ngInject';

    var _this = this;
    var englishRoutes = {
      startState: {
        name: 'start',
        url: '/',
        component: 'hqToolsLightingStart',
      },
      stepRoomState: {
        name: 'room',
        url: '/room',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'room';
          },
          nextStep: function () {
            return 'fixture';
          },
          prevStep: function () {
            return 'start';
          },
          zoomModal: function () {
            return false;
          },
        },
      },
      stepFixtureState: {
        name: 'fixture',
        url: '/fixture',
        component: 'hqToolsLightingStepFixture',
      },
      stepBaseState: {
        name: 'base',
        url: '/base',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'base';
          },
          nextStep: function () {
            return 'lumen';
          },
          prevStep: function () {
            return 'room';
          },
          zoomModal: function () {
            return false;
          },
        },
      },
      stepLumenState: {
        name: 'lumen',
        url: '/lumens',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'lumen';
          },
          nextStep: function () {
            return 'kelvins';
          },
          prevStep: function () {
            return 'base';
          },
          zoomModal: function () {
            return false;
          },
        }
      },
      stepKelvinsState: {
        name: 'kelvins',
        url: '/kelvins',
        component: 'hqToolsLightingStepKelvins',
      },
      endState: {
        name: 'end',
        url: '/recommendation',
        component: 'hqToolsLightingEnd',
      },
    };

    var frenchRoutes = {
      startState: {
        name: 'start',
        url: '/',
        component: 'hqToolsLightingStart',
      },
      stepRoomState: {
        name: 'room',
        url: '/piece',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'room';
          },
          nextStep: function () {
            return 'fixture';
          },
          prevStep: function () {
            return 'start';
          },
          zoomModal: function () {
            return false;
          },
        },
      },
      stepFixtureState: {
        name: 'fixture',
        url: '/luminaire',
        component: 'hqToolsLightingStepFixture',
      },
      stepBaseState: {
        name: 'base',
        url: '/culot',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'base';
          },
          nextStep: function () {
            return 'lumen';
          },
          prevStep: function () {
            return 'fixture';
          },
          zoomModal: function () {
            return false;
          },
        },
      },
      stepLumenState: {
        name: 'lumen',
        url: '/lumens',
        component: 'hqToolsLightingStepSelection',
        resolve: {
          stepName: function () {
            return 'lumen';
          },
          nextStep: function () {
            return 'kelvins';
          },
          prevStep: function () {
            return 'base';
          },
          zoomModal: function () {
            return false;
          },
        }
      },
      stepKelvinsState: {
        name: 'kelvins',
        url: '/kelvins',
        component: 'hqToolsLightingStepKelvins',
      },
      endState: {
        name: 'end',
        url: '/recommendation',
        component: 'hqToolsLightingEnd',
      },
    };

    /**
     * @ngdoc method
     * @name setState
     * @methodOf hqTLightingRouterProvider
     * @description Set app's router state.
     * @example
     * @returns {hqTLightingRouterProvider} Returns self for chaining
     * <pre>
     * hqTLightingRouterProvider
     *   .setState();
     * </pre>
     */
    this.setState = function () {
      var routes = frenchRoutes;

      if (hqTLightingLanguageProvider.currentLanguage === 'en') {
        routes = englishRoutes;
      }

      $urlRouterProvider.otherwise('/');

      Object.keys(routes).forEach(function (route) {
        if (
          Object.prototype.hasOwnProperty.call(routes, route) &&
          routes[route].name &&
          routes[route].url &&
          routes[route].component
        ) {
          $stateProvider.state(routes[route]);
        }
      });

      return _this;
    };

    this.$get = function () {
      return null;
    };
  }
}());
